import { useSelector } from "react-redux";
import { useGetDealsDetailsQuery } from "../../../redux/api/DealsPdf";
import { selectCurrentAgent } from "../../../redux/features/authSlice";
import Loader from "../../../components/loader/Loader";
import { Link } from "react-router-dom";
import { PROPERTY_PDFS_URL } from "../../../constants/url";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import { Box, Button, styled, Typography, useMediaQuery } from "@mui/material";
import { DEAL_COLUMN } from "./dealsData";
import MaterialReactTable from "material-react-table";

export const DealsPdf = () => {
  const isMobileScreen = useMediaQuery("(max-width:768px)");
  const currentAgent = useSelector(selectCurrentAgent);
  const { data, isLoading, error } = useGetDealsDetailsQuery({
    agcid: currentAgent.agencyid,
    agtid: currentAgent.agentid,
  });
  const agentEarning = data?.AgentsEarnings[0]?.TotalAgentEarning?.toFixed(2);
  const agentDeals = data?.agentDealCounts[0]?.DealCount;
  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb={2}
        sx={{
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "flex-start", sm: "center" },
        }}
      >
        <Typography variant="h2" sx={{ mb: { xs: 2, sm: 0 } }}>
          All Deals Report
        </Typography>
        <Box display="flex" gap={2}>
          <StyledButton variant="contained" sx={{ color: "white" }}>
            Total Earning {agentEarning}
          </StyledButton>
          <StyledButton variant="contained" sx={{ color: "white" }}>
            Total Deals {agentDeals}
          </StyledButton>
        </Box>
      </Box>
      <MaterialReactTable
        state={{ showSkeletons: isLoading }}
        columns={DEAL_COLUMN}
        data={data?.dealInfo ?? []}
        initialState={{ display: "compact", pagination: { pageSize: 20 } }}
        enableRowActions={false}
        muiTableContainerProps={{
          sx: { maxHeight: isMobileScreen ? "100%" : "calc(100vh - 320px)" },
        }}
      />
    </>
  );
};
const StyledButton = styled(Button)(({ theme }) => ({
  marginRight: "8px",
}));
